import { Component, computed, input, model, output, viewChild } from '@angular/core';
import { NgClass, TitleCasePipe } from '@angular/common';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { OptionsAction } from '@app/framework/overlays/option-list.constants';
import { OverlayGeneralComponent } from '@app/framework/overlays/overlay-general/overlay-general.component';
import { TooltipDirective } from '@app/directives/tooltip.directive';

@Component({
  selector: 'app-options-list-simple',
  templateUrl: './options-list-simple.component.html',
  styleUrls: ['./options-list-simple.component.scss'],
  imports: [NgClass, CdkOverlayOrigin, TitleCasePipe, OverlayGeneralComponent, TooltipDirective],
  host: {
    '(click)': '!this.disabled() && toggleShow()',
  },
})
export class OptionsListSimpleComponent {
  trigger = input<CdkOverlayOrigin>();
  show = model(false);

  disabled = input<boolean>(false);
  actions = input<OptionsAction[]>();
  internalOverlayOrigin = viewChild(CdkOverlayOrigin);
  stopIconClickPropagation = input<boolean>(true);

  optionSelected = output<OptionsAction>();

  computedCdkOverlayOrigin = computed(() => {
    if (this.trigger()) {
      return this.trigger();
    }
    return this.internalOverlayOrigin();
  });

  onOptionSelected(item: OptionsAction) {
    this.optionSelected.emit(item);
  }

  onIconClick(event: MouseEvent) {
    if (this.stopIconClickPropagation()) {
      event.stopPropagation();
    }
    this.toggleShow(true);
  }

  toggleShow(value?: boolean) {
    if (value !== undefined) {
      this.show.set(value);
    } else {
      this.show.update((value) => !value);
    }
  }
}
